import React, { useState } from 'react';
import { cn } from "../lib/utils";

const SessionCard = ({
  title,
  subtitle,
  description,
  imageSrc,
  imageAlt,
  className,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div
      className={cn(
        "group relative flex flex-col justify-between p-6 w-full bg-black rounded-lg overflow-hidden shadow-lg transition-all duration-500",
        "h-[350px] md:w-1/3 md:h-[350px] lg:h-[450px] md:hover:w-2/3",
        isExpanded && "h-auto pb-8 md:h-[350px] lg:md:h-[450px]",
        className
      )}
      onClick={() => setIsExpanded(!isExpanded)}
    >
      <img
        src={imageSrc}
        className="absolute inset-0 w-full h-full object-cover object-center"
        alt={imageAlt || title}
      />
      <div className="absolute inset-0 bg-black bg-opacity-60"></div>
      
      {/* Title - moves from bottom to top on hover (desktop) or click (mobile) */}
      <div className={cn(
        "left-6 right-6 z-10 space-y-2 transition-all duration-500",
        "absolute bottom-6 md:group-hover:top-6 md:group-hover:bottom-auto",
        isExpanded && "relative top-6 md:absolute md:bottom-6 md:top-auto md:group-hover:top-6 md:group-hover:bottom-auto"
      )}>
        <h2 className="text-xl font-bold text-white">{title}</h2>
        <p className={cn(
          "text-sm text-gray-300",
          isExpanded && "hidden md:block"
        )}>{subtitle}</p>
      </div>
      
      {/* Description - appears on hover (desktop) or click (mobile) */}
      <div className={cn(
        "absolute left-6 right-6 bottom-6 z-10 transition-all duration-200",
        "transform translate-y-4 opacity-0 pointer-events-none",
        "md:group-hover:opacity-100 md:group-hover:translate-y-0 md:group-hover:delay-500 md:group-hover:pointer-events-auto",
        isExpanded && "relative opacity-100 translate-y-0 pointer-events-auto px-0 pb-2 mt-14 md:absolute md:opacity-0 md:translate-y-4 md:pointer-events-none md:group-hover:opacity-100 md:group-hover:translate-y-0 md:group-hover:pointer-events-auto md:mt-0"
      )}>
        <p 
          className={cn(
            "text-white",
            "text-sm leading-relaxed md:text-lg md:leading-normal",
            !isExpanded && "md:text-justify"
          )} 
        >
          {description}
        </p>
      </div>
    </div>
  );
};

export function SessionalHoverCards({
  cards,
  className,
}) {
  return (
    <div className={cn("flex flex-wrap md:flex-nowrap gap-4 w-full px-4", className)}>
      {cards.map((card, index) => (
        <SessionCard
          key={index}
          title={card.title}
          subtitle={card.subtitle}
          description={card.description}
          imageSrc={card.imageSrc}
          imageAlt={card.imageAlt}
        />
      ))}
    </div>
  );
}
